import { classNames } from 'primereact/utils';
import React from 'react';

const FormInputWidth = {
    LARGE: 'lg',
    SMALL: 'sm'
};

const FormInputType = {
    CHECKBOX: 'checkbox'
};

type FormInputProps = {
    children: React.ReactNode;
    readonly?: boolean;
    width?: 'lg' | 'sm';
    type?: 'checkbox';
    className?: string;
};

export const FormInput = ({ children, readonly, width, type, className }: FormInputProps) => {
    return (
        <div
            className={classNames(
                'form-input',
                {
                    'form-input--readonly': readonly,
                    'form-input--long': width === FormInputWidth.LARGE,
                    'form-input--short': width === FormInputWidth.SMALL,
                    'form-input--checkbox': type === FormInputType.CHECKBOX
                },
                className
            )}
        >
            {children}
        </div>
    );
};
